import { throttle } from 'lodash';
import { useEffect, useState } from 'react';

import { isMobile } from 'utils/width';

const useIsMobile = (
  maxWidth: number | undefined = undefined,
  initialValue = false
): boolean => {
  const [isMobileView, setIsMobileView] = useState(initialValue);

  useEffect(() => {
    const calculateIsMobileView = () => {
      if (window) {
        if (maxWidth) {
          // `isMobile`'s second parameter is inferred as `undefined` because of
          // its default value in utils/width; cast to pass the real max width
          // without altering runtime behaviour.
          setIsMobileView(
            isMobile(window.innerWidth, maxWidth as unknown as undefined)
          );
        } else {
          setIsMobileView(isMobile(window.innerWidth));
        }
      }
    };

    calculateIsMobileView();

    const throttledCalculateIsMobileView = throttle(calculateIsMobileView, 500);

    if (window) {
      window.addEventListener('resize', throttledCalculateIsMobileView);
    }

    return () => {
      window.removeEventListener('resize', throttledCalculateIsMobileView);
    };
  }, [maxWidth]);

  return isMobileView;
};

export default useIsMobile;
